import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=5116aca7&scoped=true&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=5116aca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116aca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5116aca7')) {
      api.createRecord('5116aca7', component.options)
    } else {
      api.reload('5116aca7', component.options)
    }
    module.hot.accept("./DashboardFooter.vue?vue&type=template&id=5116aca7&scoped=true&", function () {
      api.rerender('5116aca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/DashboardFooter.vue"
export default component.exports